// extracted by mini-css-extract-plugin
export default {"header":"GroupsView-module__header--S7lh1","emptyStateContainer":"GroupsView-module__emptyStateContainer--cI2CN","groupCards":"GroupsView-module__groupCards--F27T_"};